import { MinMax } from "src/types";

/**
 * Utilities to manage a SubstanceMinMax list
 * inspired by functional programming paradigm:
 *   CRC (Construct, Reduce, Convert)
 */

type SubstanceMinMax = { [key: string]: MinMax };

export function create() {
  return {};
}

export function get(list: SubstanceMinMax, substanceId: string | number) {
  return list[substanceId];
}

export function set(list: SubstanceMinMax, substanceId: string | number, minMax: MinMax) {
  return { ...list, [substanceId]: minMax };
}

export function setOnlyInitial(list: SubstanceMinMax, substanceId: string | number, minMax: MinMax) {
  if (Object.keys(list).includes(substanceId.toString())) return list;
  else return { ...list, [substanceId]: minMax };
}
